import { useGetContext } from "@onefront/forrestjs-react-root";
import { buildUrl } from "../utils/build-url";

/**
 * login://foo/bar
 * -> /api/redirect/to=login...
 *
 * https://foo/bar (todo)
 * -> https://foo/bar
 */
export const useTargetUrl = (target, params) => {
  const proxyBaseUrl = useGetContext("one.axios.proxy.baseUrl");
  const url = addParamsToTarget(target, params);
  const redirectUrl = `redirect?to=${encodeURIComponent(url)}`;

  return {
    loading: false,
    error: null,
    url: buildUrl({ target, proxyBaseUrl, stringToJoin: redirectUrl })
  };
};


function addParamsToTarget(target, params) {
  if (target.indexOf("://") >= 0) {
    return params ? `${target}?${params?.join("&")}` : target; 
  }
  
  return params ? `${target}://?${params?.join("&")}` : target;
}